module.exports = __webpack_public_path__ + "img/enotas.f9db7d01.svg";